import React from "react"
import Blockies, { IdenticonProps } from "react-blockies"

export type AvatarBlockProps = IdenticonProps

export const AvatarBlock: React.FunctionComponent<AvatarBlockProps> = props => {
  return (
    <Blockies
      size={9}
      scale={3}
      color="#95673C"
      bgColor="#7AE8CE"
      spotColor="#7AE8CE"
      {...props}
      seed={props.seed || "Jeremy"}
    />
  )
}
